/* eslint-disable */
import React from 'react';
import { Check } from '../../components/ui/check/Check';
import { Option } from '../../components/ui/check/Option';
import { useStore } from '../../store/store';
import { useNav } from '../../hooks/nav';
import Analytics from '@web-solutions/module-analytics';
import { t } from '@web-solutions/module-localization';
import { Title } from 'src/onboarding/components/typography/Title/Title';
import { ReactComponent as BackIcon } from '../../assets/images/arrowLeft.svg';

function Page() {
  const energyLevels = useStore((state) => state.energyLevels);
  const setEnergyLevels = useStore((state) => state.setEnergyLevels);
  const { onNext, onPrev, currentIndex } = useNav();

  return (
    <div className={'page'}>
      {currentIndex !== 0 && (
        <div className={'back'} onClick={onPrev}>
          <BackIcon />
        </div>
      )}
      <div className={'wrapper-info'}>
        <Title tag='h2'>{t('onboarding.energyLevels.title')}</Title>
      </div>

      <div className={'controls'}>
        <Check
          defaultValue={energyLevels}
          onChange={(value) => {
            setEnergyLevels(value);
            Analytics.trackEvent(`step${currentIndex + 1}`, 'complete', {
              page: 'energy-levels',
              answer: value,
            });
            onNext();
          }}
        >
          <Option value={'low'}>
            <span>😴</span> {t('onboarding.energyLevels.options.low')}
          </Option>
          <Option value={'lunchSlump'}>
            <span>🥱</span> {t('onboarding.energyLevels.options.lunchSlump')}
          </Option>
          <Option value={'beforeMeals'}>
            <span>😕</span> {t('onboarding.energyLevels.options.beforeMeals')}
          </Option>
          <Option value={'high'}>
            <span>🤩</span> {t('onboarding.energyLevels.options.high')}
          </Option>
        </Check>
      </div>
    </div>
  );
}
export default Page;
